import * as React from "react"
import "./styles.scss"

const TABS_LABELS = {
    'gift': 'Gifts',
    'passport': 'Product Passport',
    'Carbon': 'CARBON',
    'Water': 'WATER',
};

export default function Tabs({tabs, selectedTab, setSelectedTab}) {
    return (
        <div className={`tab-menu`}>
            {tabs.map((tab) => (
                <div key={tab} className={`tab-menu-item ${selectedTab === tab ? 'active' : ''}`}>
                    <button onClick={() => setSelectedTab(tab)}>
                        { TABS_LABELS[tab] }
                    </button>
                </div>
            ))}
        </div>
    )
}
